import { createContext } from 'react'

export const FilteredDataContext = createContext<FilteredData | null>(null)
